import getExtensionSettings from './get-extension-settings';
import getExtension from './get-extension';

export default {
  getExtensionSettings,
  getExtension,
};
